import React from 'react';
import styled from 'styled-components';
import { FaUserGraduate, FaTrophy, FaProjectDiagram, FaFileAlt } from 'react-icons/fa';
import SectionHeader from '../common/SectionHeader';

const StatsSection = styled.section`
  padding: 80px 0;
`;

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    grid-template-columns: 1fr;
  }
`;

const StatBox = styled.div`
  background-color: ${props => props.theme.colors.lightColor};
  padding: 30px;
  border-radius: ${props => props.theme.borders.radius.regular};
  text-align: center;
  box-shadow: ${props => props.theme.shadows.regular};
  transition: ${props => props.theme.transitions.main};
  
  &:hover {
    transform: translateY(-10px);
  }
`;

const StatIcon = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: rgba(52, 152, 219, 0.1);
  color: ${props => props.theme.colors.primaryColor};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  margin: 0 auto 20px;
`;

const StatNumber = styled.div`
  font-size: 2.5rem;
  font-weight: ${props => props.theme.fontWeights.bold};
  color: ${props => props.theme.colors.secondaryColor};
  margin-bottom: 10px;
`;

const StatTitle = styled.div`
  color: ${props => props.theme.colors.grey[600]};
  font-weight: ${props => props.theme.fontWeights.semiBold};
`;

const SuccessStats = () => {
  const stats = [
    {
      icon: <FaUserGraduate />,
      number: '500+',
      title: 'Students Trained'
    },
    {
      icon: <FaTrophy />,
      number: '85%',
      title: 'Success Rate in TNPSC Exams'
    },
    {
      icon: <FaProjectDiagram />,
      number: '50+',
      title: 'Completed Projects'
    },
    {
      icon: <FaFileAlt />,
      number: '25+',
      title: 'Research Publications'
    }
  ];

  return (
    <StatsSection>
      <div className="container">
        <SectionHeader 
          title="Our Success By Numbers" 
          subtitle="Achievements that define our excellence" 
        />
        
        <StatsGrid>
          {stats.map((stat, index) => (
            <StatBox key={index}>
              <StatIcon>{stat.icon}</StatIcon>
              <StatNumber>{stat.number}</StatNumber>
              <StatTitle>{stat.title}</StatTitle>
            </StatBox>
          ))}
        </StatsGrid>
      </div>
    </StatsSection>
  );
};

export default SuccessStats;
